import Model from '@/models/Model.js';

export default class FlashcardActivityTemplate extends Model {
    static entity = 'flashcard_activity_templates';

    static modelName = 'FlashcardActivityTemplate';

    static fields() {
        return {
            content: this.attr(null),
            flashcard_set_id: this.attr(null),

            ...super.fields(),
        };
    }
}
